import { HTTP_STATUS_SUCCESS_MESSAGE } from "../constants/app-constants";
import { manageCustomerUrls } from "../constants/CustomerConstants";
import { deleteRequest, getRequest, postRequest, putRequest } from "./axios";

export const processResponse = (response, HTTP_STATUS_SUCCESS_MESSAGE) => {
  const { success, data, message, totalCount, hasMore } = response;
  const result = {
    isSuccessful: false,
    data,
    message: message,
    totalCount,
    hasMore,
  };
  if (success === HTTP_STATUS_SUCCESS_MESSAGE) {
    result.isSuccessful = HTTP_STATUS_SUCCESS_MESSAGE;
  }
  return result;
};

export const fetchManageCustomer = async (page, pageSize) => {
  const response = await getRequest(`${manageCustomerUrls.customer_detials_url}?page=${page}&pageSize=${pageSize}`);
  return processResponse(response, HTTP_STATUS_SUCCESS_MESSAGE);
};

export const searchCustomerContactDetails = async (customerId) => {
  const response = await getRequest(`${manageCustomerUrls.customer_detials_url}/search?customerId=${customerId}`);
  return processResponse(response, HTTP_STATUS_SUCCESS_MESSAGE);
};

export const createNewCustomer = async (payload) => {
  const response = await postRequest(manageCustomerUrls.customer_detials_url, payload);
  return processResponse(response, HTTP_STATUS_SUCCESS_MESSAGE);
};

export const updateCustomerById = async (id, payload) => {
  const response = await putRequest(`${manageCustomerUrls.customer_detials_url}/${id}`, payload);
  return processResponse(response, HTTP_STATUS_SUCCESS_MESSAGE);
};

export const deleteCustomerById = async (id) => {
  const response = await deleteRequest(`${manageCustomerUrls.customer_detials_url}/${id}`);
  return processResponse(response, HTTP_STATUS_SUCCESS_MESSAGE);
};
